import { createReducer, on } from '@ngrx/store';
import { ApikeyActions } from './apikey.actions';
import { Apikey, ApikeyData } from '../../../shared/interfaces/apikey.interfaces';

export const apikeyFeatureKey = 'apikey';

export interface ApikeyState {
  apikeys?: ApikeyData[] | undefined;
  lastApikey?: Apikey | undefined;
};

export const initialState: ApikeyState = {
};

export const apikeyReducer = createReducer(
  initialState,

  on(ApikeyActions.loadApikeysSuccess, (state, action) => { return { ...state, apikeys: action.data } }),

  on(ApikeyActions.createApikeySuccess, (state, action) => { return { ...state, lastApikey: action.data } }),

  on(ApikeyActions.unsetApikeyStore, () => initialState)
);
